import { render, staticRenderFns } from "./grid-col-responsive-editor.vue?vue&type=template&id=55ac54e3&scoped=true&"
import script from "./grid-col-responsive-editor.vue?vue&type=script&lang=js&"
export * from "./grid-col-responsive-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac54e3",
  null
  
)

export default component.exports